// apiConfig.js
const API_BASE_URL = 'https://iitscode.com/iits_backend';

// const API_BASE_URL = 'http://localhost/iits_backend';

export default API_BASE_URL;
